var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrap",class:{
    'is-mobile': _vm.isMobile,
    'is-dialog': _vm.isDialog,
    'zlzp-footer': _vm.hasCustomLoginPage,
    'is-pc': !_vm.isMobile,
    [`${_vm.layoutId}-layout`]: true,
  },style:(_vm.backgroundStyle)},[_vm._t("container"),(_vm.hasCustomLoginPage)?_c('LoginFooter',{attrs:{"logoColor":_vm.hasCustomLoginPage}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }